import Modal from './Modal'
import { useState } from 'react'
import Map from './DirectionMap'

//Vars
const googleMapsApiKey = 'AIzaSyB1nIgZ3jE9Vn7bdZu5r8lZ5Yhwryf-ZY0'

function SourcedFrom (props) {
    const [modal, setModal] = useState(false)
    const { refProcessSteps } = props.route

    const renderMap = () => {

        const places = []
        refProcessSteps.map((o) => {

            if (o.latitude && o.latitude !== 0 && o.longitude && o.longitude !== 0)
                places.push({ lat: parseFloat(o.latitude), lng: parseFloat(o.longitude) })

            return o

        })

        return places.length > 0 && <Map
            googleMapsApiKey={googleMapsApiKey}
            markers={places}
            center={places[0]}
            zoom={2}
        />
    }

    return <div className='' >
        <div className="beigeBox customShadow customRadius px-2"  onClick={() => setModal(!modal)}> 
            <div className='beigeBoxTitleWrap p-3'>
                <small>Sourced From</small>
                <h3>Tanzania</h3>
            </div>
            <div className='p-3'>
                <img src={require('./assets/GlobeIcon.png').default} width="80px" alt="Sourced From Tanzania" />
            </div>
        </div>
        {modal && <Modal title="Sourced From" modal={modal} toggleModal={setModal}>{renderMap()}</Modal>}
    </div>
}

export default SourcedFrom